<template>
  <div class="app-wrapper">
    <div class="sidebar-container">
      <div class="logo">
        <span class="logo-icon">拼</span>
        <span class="logo-text">拼拼车</span>
      </div>
      <el-menu
        :default-active="$route.path"
        background-color="#001529"
        text-color="rgba(255,255,255,0.65)"
        active-text-color="#fff"
        router
        unique-opened
      >
        <template v-for="route in menuRoutes">
          <el-submenu v-if="route.children && route.children.length > 1" :key="route.path" :index="route.path">
            <template slot="title">
              <i :class="route.meta && route.meta.icon"></i>
              <span>{{ route.meta && route.meta.title }}</span>
            </template>
            <el-menu-item v-for="child in route.children" :key="child.path" :index="route.path + '/' + child.path">
              {{ child.meta.title }}
            </el-menu-item>
          </el-submenu>
          <el-menu-item v-else-if="route.children" :key="route.path + '-single'" :index="getPath(route)">
            <i :class="(route.children[0].meta && route.children[0].meta.icon) || (route.meta && route.meta.icon)"></i>
            <span slot="title">{{ (route.children[0].meta && route.children[0].meta.title) }}</span>
          </el-menu-item>
        </template>
      </el-menu>
    </div>
    <div class="main-container">
      <div class="navbar">
        <div class="breadcrumb">
          <i class="el-icon-location-outline"></i>
          {{ pageTitle }}
        </div>
        <div class="right-menu">
          <el-avatar :size="32" icon="el-icon-user-solid" class="avatar"></el-avatar>
          <span class="admin-name">{{ adminName }}</span>
          <el-button type="text" class="logout-btn" @click="logout"><i class="el-icon-switch-button"></i> 退出</el-button>
        </div>
      </div>
      <div class="app-main">
        <router-view />
      </div>
    </div>
  </div>
</template>

<script>
import { constantRoutes } from '@/router'
import { mapGetters } from 'vuex'

export default {
  name: 'Layout',
  computed: {
    ...mapGetters(['admin']),
    adminName() { return (this.admin && this.admin.real_name) || '管理员' },
    menuRoutes() {
      return constantRoutes.filter(r => r.path !== '/login' && r.children)
    },
    pageTitle() {
      const matched = this.$route.matched
      const last = matched[matched.length - 1]
      return (last && last.meta && last.meta.title) || '拼拼车'
    }
  },
  methods: {
    getPath(route) {
      const child = route.children[0]
      if (child.path.includes('/')) return child.path
      return route.path === '/' ? '/' + child.path : route.path + '/' + child.path
    },
    async logout() {
      await this.$store.dispatch('user/logout')
      this.$router.replace('/login')
    }
  }
}
</script>

<style lang="scss" scoped>
.app-wrapper { display: flex; height: 100vh; }
.sidebar-container {
  width: 230px; background: $sidebar-bg; flex-shrink: 0;
  box-shadow: 2px 0 8px rgba(0,0,0,0.08);
  .logo {
    height: 56px; display: flex; align-items: center; padding: 0 20px;
    border-bottom: 1px solid rgba(255,255,255,0.06);
    .logo-icon {
      width: 36px; height: 36px; background: linear-gradient(135deg, $primary, $primary-dark);
      border-radius: 10px; color: #fff; text-align: center; line-height: 36px; font-weight: 800; font-size: 18px;
    }
    .logo-text { color: #fff; margin-left: 12px; font-size: 17px; font-weight: 700; letter-spacing: 1px; }
  }
  ::v-deep .el-menu { border-right: none; }
  ::v-deep .el-menu-item.is-active { background: $primary !important; border-radius: 0 24px 24px 0; margin-right: 8px; }
  ::v-deep .el-submenu__title:hover, ::v-deep .el-menu-item:hover { background: rgba(255,255,255,0.06) !important; }
}
.main-container { flex: 1; display: flex; flex-direction: column; overflow: hidden; background: $bg-page; }
.navbar {
  height: 56px; background: #fff; box-shadow: 0 1px 4px rgba(0,21,41,.06);
  display: flex; align-items: center; justify-content: space-between; padding: 0 24px;
  .breadcrumb { font-size: 15px; font-weight: 600; color: $text-primary; i { margin-right: 6px; color: $primary; } }
  .right-menu { display: flex; align-items: center; gap: 10px; }
  .avatar { background: $primary; }
  .admin-name { color: $text-secondary; font-size: 14px; }
  .logout-btn { color: $text-secondary; &:hover { color: #ff4d4f; } }
}
.app-main { flex: 1; overflow: auto; }
</style>
